import Shelf from "./shelf/shelf.component";
import PricingAvailability, {
  AvailabilityOption,
} from "./pricingAvailability/PricingAvailability";
import Message from "./Message/Message";

interface InventoryNoResultsProps {
  InventoryStatusMessage: string;
  InventoryStatusCode: number;
}

const InventoryNoResults = ({
  InventoryStatusMessage,
  InventoryStatusCode,
}: InventoryNoResultsProps) => (
  <Shelf mobile="20" tablet="25" desktop="25">
    <PricingAvailability
      availabilityOption={
        InventoryStatusCode === 2
          ? AvailabilityOption.NoResult
          : AvailabilityOption.NoCatalogs
      }
    >
      <Message text={InventoryStatusMessage} />
    </PricingAvailability>
  </Shelf>
);

export default InventoryNoResults;
